/* eslint-disable @typescript-eslint/prefer-for-of */
import { ICascaderItem, AnyObjType, TreeFieldType, GroupItem } from '../interface';
export const flatList = (list: ICascaderItem[]): ICascaderItem[] => {
  const result: ICascaderItem[] = [];
  function fn(fnList: ICascaderItem[]) {
    fnList.forEach((item: ICascaderItem) => {
      if (item.children?.length) {
        result.push(item);
        fn(item.children);
      } else {
        result.push(item);
      }
    });
  }
  fn(list);
  return result;
};

export const getTreeFirstItem = (
  treeData: ICascaderItem[] = [],
  valueList: (string | number)[] = []
): ICascaderItem | null => {
  let result: null | ICascaderItem = null;
  if (!valueList.length) {
    return result;
  }
  let fined = false;
  function fn(fnList: ICascaderItem[] = []) {
    for (let i = 0; i < fnList.length; i += 1) {
      if (fined) {
        break;
      }
      const item: ICascaderItem = fnList[i];
      const { children = [], ...otherProps } = item;
      if (valueList.includes(otherProps.value)) {
        fined = true;
        result = otherProps;
        break;
      }
      if (children?.length) {
        fn(children);
      }
    }
  }
  fn(treeData);
  return result;
};

// 通过value反找自己的所有父级
export const getSelectedListByValue = (
  treeData: ICascaderItem[] = [],
  value: (string | number)[] | string | number
): GroupItem[] => {
  const result: GroupItem[] = [];
  let fined = false;
  let tempList: GroupItem[] = [];
  if (!value) {
    return result;
  }
  function fn(fnList: ICascaderItem[] = [], deep: number): boolean {
    let result = false;
    for (let i = 0; i < fnList.length; i += 1) {
      if (fined) {
        break;
      }
      if (deep === 1) {
        tempList = [];
      }
      const item = fnList[i];
      const { children = [], ...otherProps } = item;
      if (otherProps.value === value) {
        fined = true;
        result = true;
        if (children?.length) {
          tempList.push({
            value: otherProps.value,
            list: children,
            deep: deep + 1
          });
        }
        break;
      }
      if (children?.length) {
        const resultChildren = fn(children, deep + 1);
        if (resultChildren) {
          tempList.push({
            value: otherProps.value,
            list: children,
            deep
          });
          return resultChildren;
        }
      }
    }
    return result;
  }
  result.push({
    value: 'FIRST_VALUE',
    deep: 0,
    list: treeData
  });
  fn(treeData, 1);
  tempList.sort((a, b) => a.deep - b.deep);
  return [...result, ...tempList];
};

// 获取只有主项的id
export const getParentIdList = (
  valueList: (string | number)[] = [],
  treeList: ICascaderItem[] = []
): (string | number)[] => {
  const result: (string | number)[] = [];
  if (!valueList.length) {
    return result;
  }
  function fn(list: ICascaderItem[] = []) {
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      if (valueList.includes(item.value) && children.length) {
        result.push(item.value);
        // eslint-disable-next-line no-continue
        continue;
      } else if (valueList.includes(item.value)) {
        result.push(item.value);
      } else if (children.length) {
        fn(children);
      }
    }
  }
  fn(treeList);
  return result;
};

// 获取说有项的id
export const getAllValueList = (
  valueList: (string | number)[] = [],
  treeList: ICascaderItem[] = []
): (string | number)[] => {
  const result: (string | number)[] = [];
  if (!valueList.length) {
    return result;
  }
  function fn(list: ICascaderItem[] = [], appendAllChildren = false) {
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      if (appendAllChildren) {
        result.push(item.value);
        if (children.length) {
          fn(children, true);
        }
      } else if (valueList.includes(item.value)) {
        result.push(item.value);
        if (children.length) {
          fn(children, true);
        }
      } else if (children.length) {
        fn(children);
      }
    }
  }
  fn(treeList, false);
  return result;
};

// 获取所有子项的id，如果子项下面还有子项就只保留叶子节点的id
export const getAllChildrenList = (
  valueList: (string | number)[] = [],
  treeList: ICascaderItem[] = []
): (string | number)[] => {
  const result: (string | number)[] = [];
  if (!valueList.length) {
    return result;
  }
  function fn(list: ICascaderItem[] = [], appendAllChildren = false) {
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      if (appendAllChildren) {
        if (children.length) {
          fn(children, appendAllChildren);
        } else {
          result.push(item.value);
        }
      } else if (valueList.includes(item.value)) {
        if (children.length) {
          fn(children, true);
        } else {
          result.push(item.value);
        }
      } else if (children.length) {
        fn(children);
      }
    }
  }
  fn(treeList, false);
  return result;
};

// 根据所有子项找到所有选中的id
export const getAllValueListByAllChildren = (
  valueList: (string | number)[] = [],
  treeList: ICascaderItem[] = []
): (string | number)[] => {
  if (!valueList.length) {
    return valueList;
  }
  const result: (string | number)[] = [...valueList];
  function fn(list: ICascaderItem[] = []): boolean {
    // 是否所有项都选中
    let checkAll = true;
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      let selected = valueList.includes(item.value);
      if (children.length) {
        const childrenCheckAll = fn(children);
        if (childrenCheckAll) {
          result.push(item.value);
          selected = true;
        }
      }
      checkAll = selected && checkAll;
    }
    return checkAll;
  }
  fn(treeList);
  return result;
};

// 删除某个节点的时候要把所有父级的选中都删除
export const getDeleteAllChildrenValue = (
  currentValue: string | number,
  treeList: ICascaderItem[] = [],
  valueList: (string | number)[] = []
): (string | number)[] => {
  // 需要删除的列表
  const deletedList: (string | number)[] = [];
  if (!valueList.length) {
    return deletedList;
  }
  function fn(list: ICascaderItem[] = [], pushInDelete = false): boolean {
    let result: boolean = pushInDelete;
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      if (pushInDelete) {
        deletedList.push(item.value);
        if (children.length) {
          fn(children, true);
        }
        // eslint-disable-next-line no-continue
        continue;
      }
      // 如果找到了当前的项,就把要移除的项找出来
      if (currentValue === item.value) {
        result = true;
        deletedList.push(item.value);
        if (children.length) {
          // 如果有子集就全部加入到列表里面
          fn(children, true);
        }
        // 如果找到就跳出
        break;
      } else {
        result = fn(children);
      }
      if (result) {
        deletedList.push(item.value);
        break;
      }
    }
    return result;
  }
  fn(treeList);
  return valueList.filter((item: string | number) => {
    return !deletedList.includes(item);
  });
};

export const getAddedList = (
  currentValue: string | number,
  treeList: ICascaderItem[] = [],
  valueList: (string | number)[] = []
): (string | number)[] => {
  const newValueList: (string | number)[] = [...valueList];
  newValueList.push(currentValue);
  function fn(list: ICascaderItem[] = []) {
    // 是否所有项都选中
    let checkAll = true;
    let thisDeepHasValue = false;
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      let selected = newValueList.includes(item.value);
      if (item.value === currentValue) {
        thisDeepHasValue = true;
      } else if (children.length && !thisDeepHasValue) {
        // 如果已经当前一级了就不向下递归了
        const childrenCheckAll = fn(children);
        // 如果下一级的都选中了，判断当前
        if (childrenCheckAll && !selected) {
          // 添加父级id
          newValueList.push(item.value);
          // 重置选中状态
          selected = true;
        }
      }
      checkAll = selected && checkAll;
    }
    return checkAll;
  }
  fn(treeList);
  return newValueList;
};

// 通过value找{label:"",value:""}的列表，方便显示
export const getListByShowParent = (
  valueList: (number | string)[] = [],
  treeList: ICascaderItem[] = []
): ICascaderItem[] => {
  const result: ICascaderItem[] = [];
  if (!Array.isArray(valueList)) {
    return result;
  }
  if (!valueList.length) {
    return result;
  }
  function fn(list: ICascaderItem[] = []) {
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      const value: string | number = item.value;
      const selected: boolean = valueList.includes(value);
      if (selected) {
        result.push({
          label: item.label,
          value: item.value,
          data: item
        });
      } else {
        fn(children);
      }
    }
  }
  fn(treeList);
  return result;
};

export const getListByShowChild = (valueList: (string | number)[], treeList: ICascaderItem[]): ICascaderItem[] => {
  const result: ICascaderItem[] = [];
  if (!valueList.length) {
    return result;
  }

  function deep(list: ICascaderItem[] = []) {
    list.forEach(item => {
      if (valueList.includes(item.value)) {
        if (item.children?.length) {
          deep(item.children);
        } else {
          result.push(item);
        }
      } else if (item.children?.length) {
        deep(item.children);
      }
    });
  }
  deep(treeList);
  return result;

  // function fn(list: ICascaderItem[] = [], deep: number) {
  //   let checkAll = true;
  //   const tempList: ICascaderItem[] = [];
  //   for (let i = 0; i < list.length; i += 1) {
  //     const item: ICascaderItem = list[i];
  //     const { children = [], ...otherProps } = item;
  //     let selected: boolean = valueList.includes(otherProps.value);
  //     if (selected) {
  //       tempList.push(otherProps);
  //     } else if (children.length) {
  //       const childrenChecked: boolean = fn(children, deep + 1);
  //       if (childrenChecked) {
  //         tempList.push(otherProps);
  //         selected = true;
  //       }
  //     }
  //     checkAll = selected && checkAll;
  //   }
  //   if (deep === 0 && checkAll) {
  //     result = result.concat(tempList);
  //   }
  //   // 如果当前这个层级的都是选中的
  //   if (!checkAll) {
  //     result = result.concat(tempList);
  //   }
  //   return checkAll;
  // }
  // fn(treeList, 0);
  // return result;
};

export const getIndeterminateList = (
  valueList: (string | number)[] = [],
  treeList: ICascaderItem[] = []
): (string | number)[] => {
  const result: (string | number)[] = [];
  if (!valueList.length) {
    return result;
  }
  function fn(list: ICascaderItem[] = [], deep = 0) {
    let resultFlag = false;
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const children: ICascaderItem[] = item.children || [];
      const selected = valueList.includes(item.value);
      if (selected && deep !== 0) {
        resultFlag = true;
      } else {
        const childrenChecked = fn(children, deep + 1);
        if (childrenChecked) {
          result.push(item.value);
          if (deep !== 0) {
            resultFlag = true;
          }
        }
      }
    }
    return resultFlag;
  }
  fn(treeList);
  return result;
};

export const setTreeDataDeep = (treeData: ICascaderItem[]): ICascaderItem[] => {
  const result: ICascaderItem[] = [];
  if (!treeData.length) {
    return result;
  }
  function fn(list: ICascaderItem[], deep: number): ICascaderItem[] {
    const resultList: ICascaderItem[] = [];
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const resultItem: ICascaderItem = <ICascaderItem>{
        label: item.label || item.title,
        value: item.value,
        deep,
        data: <AnyObjType>item,
        children: <ICascaderItem[]>[]
      };
      const childList: ICascaderItem[] = <ICascaderItem[]>item.children;
      if (childList?.length) {
        resultItem.children = fn(<ICascaderItem[]>(<unknown>childList), deep + 1);
      }
      resultList.push(resultItem);
    }
    return resultList;
  }

  return fn(treeData, 0);
};

export const formatTreeData = (treeData: AnyObjType[], fieldNames: TreeFieldType): ICascaderItem[] => {
  const { label = 'label', value = 'value', children = 'children' } = fieldNames;
  const result: ICascaderItem[] = [];
  if (!treeData.length) {
    return result;
  }
  function fn(list: AnyObjType[], deep: number) {
    const resultList: ICascaderItem[] = [];
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i];
      const resultItem: ICascaderItem = {
        label: '',
        value: '',
        deep,
        data: item
      };
      const labelStr = item[label] || '';
      const valueStr = item[value] || '';
      const childrenList = item[children];
      if (typeof labelStr === 'string' || typeof labelStr === 'number') {
        resultItem.label = labelStr;
      }
      if (typeof valueStr === 'string' || typeof valueStr === 'number') {
        resultItem.value = valueStr;
      }
      if (Array.isArray(childrenList) && childrenList.length) {
        resultItem.children = fn(childrenList, deep + 1);
      }
      resultList.push(resultItem);
    }
    return resultList;
  }
  return fn(treeData, 0);
};

export const searchList = (treeData: ICascaderItem[], search: string): ICascaderItem[] => {
  if (!search) {
    return treeData;
  }
  const resultList: ICascaderItem[] = [];
  function fn(list: ICascaderItem[] = []) {
    for (let i = 0; i < list.length; i += 1) {
      const item: ICascaderItem = list[i];
      const { label, children, title, data } = item;
      // rawId 可能在 item 上，也可能在 data 中（经过 setTreeDataDeep 处理后）
      const rawId = (item as AnyObjType).rawId || (data as AnyObjType)?.rawId;
      if (label) {
        if (label.toString().indexOf(search) > -1) {
          resultList.push({ ...item });
          // eslint-disable-next-line no-continue
          continue;
        }
      } else if (title) {
        if (title.toString().indexOf(search) > -1) {
          resultList.push({ ...item });
          // eslint-disable-next-line no-continue
          continue;
        }
      }

      // 支持通过 rawId 搜索（用于渠道 ID 搜索）
      if (rawId && rawId.toString().indexOf(search) > -1) {
        resultList.push({ ...item });
        // eslint-disable-next-line no-continue
        continue;
      }

      if (children?.length) {
        fn(children);
      }
    }
  }
  fn(treeData);
  return resultList;
};

export default {
  flatList,
  getTreeFirstItem
};
